import MapboxDraw, { type DrawCustomMode } from '@mapbox/mapbox-gl-draw';
import { cloneDeep } from 'lodash';

export const SimpleSelectMode = cloneDeep(MapboxDraw.modes.simple_select) as DrawCustomMode;
